<template>
<div class="chapter">
<div class="inner_page">
<div class="preface" id="fm1">
<p class="center"><span class="big2"><strong>Doonesbury Books by G. B. Trudeau</strong></span></p>
<p class="center"><span class="big2"><strong>Recent Collections</strong></span><br/>Read My Lips, Make My Day, Eat Quiche and Die!<br/>Give Those Nymphs Some Hooters!<br/>You’re Smokin’ Now, Mr. Butts!<br/>I’d Go with the Helmet, Ray<br/>Welcome to Club Scud!<br/>What Is It, Tink, Is Pan in Trouble?<br/>Quality Time on Highway 1<br/>Washed Out Bridges and Other Disasters<br/>In Search of Cigarette Holder Man<br/>Doonesbury Nation<br/>Virtual Doonesbury<br/>Planet Doonesbury<br/>Buck Wild Doonesbury<br/>Duke 2000: Whatever It Takes<br/>The Revolt of the English Majors<br/>Peace Out, Dawg!<br/>Got War?<br/>Talk to the Hand<br/>Dude: The Big Book of Zonker<br/>Heckuva Job, Bushie!<br/>Welcome to the Nerd Farm!<br/><br/></p>
<p class="center"><span class="big2"><strong>Special Collections</strong></span><br/>The Doonesbury Chronicles<br/>Doonesbury’s Greatest Hits<br/>The People’s Doonesbury<br/>Doonesbury Dossier: The Reagan Years<br/>Doonesbury Deluxe: Selected Glances Askance<br/>Recycled Doonesbury: Second Thoughts on a Gilded Age<br/>Action Figure!<br/>The Portable Doonesbury<br/>Flashbacks: Twenty-Five Years of Doonesbury<br/>The Bundled Doonesbury<br/>The Long Road Home: One Step at a Time<br/>The War Within: One More Step at a Time<br/>Doonesbury.com’s The Sandbox: Dispatches from Troops in Iraq and Afghanistan<br/>Doonesbury.com’s The War in Quotes</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780740798849_epub_fm1_r1.vue?2d4f74d0